<template>
    <div>
        <loading
            :active.sync="loadingApp"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            @close="toast.show = false"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light">
            <div class="left">
                <a
                    href="Javascript:;"
                    class="headerButton"
                    @click="$router.go(-1)"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </a>
            </div>
            <div class="pageTitle">Agen Affiliate Plus</div>
        </div>
        <!-- * App Header -->
        <div id="appCapsule" v-if="loadingApp == false">
            <!-- * Banner Informasi & Promo -->
            <div class="section mt-2 mb-2">
                <router-link :to="{ name: 'referral.upgrade' }">
                    <img
                        v-lazyload
                        :src="require('@/assets/loading_banner.jpg')"
                        :data-src="
                            require('@/assets/banner/agen_affiliate_plus.jpg')
                        "
                        alt="image"
                        class="w-100"
                        style="border-radius: 10px"
                    />
                </router-link>
            </div>
            <div class="section mt-3 mb-3">
                <div class="section-heading">
                    <h2 class="title">Tentang Agen Affiliate Plus</h2>
                </div>
                <div
                    class="padding"
                    style="
                        line-height: 18px;
                        font-size: 12px;
                        text-align: justify;
                    "
                >
                    <p>
                        Jadilah bagian eksklusif dari
                        <b>Agen Affiliate Plus</b> dan raih keuntungan lebih
                        besar dari program affiliate biasa! Sebagai Agen
                        Affiliate Plus, Anda tidak hanya menikmati komisi
                        reguler, tetapi juga berpeluang mendapatkan insentif
                        tambahan berdasarkan tier pencapaian transaksi downline
                        Anda setiap bulannya.
                    </p>
                    <p>
                        Tunggu, masih ada lagi!<br />
                        Sebagai Agen Affiliate Plus, Anda juga berkesempatan
                        meraih
                        <b>bonus tambahan berupa poin eksklusif</b> melalui
                        <b>Leader Board Agen Affiliate Plus</b>. Raih posisi 1,
                        2, atau 3 setiap bulannya, dan dapatkan reward menarik
                        yang akan membuat perjalanan affiliate Anda semakin
                        menguntungkan! Jangan lewatkan kesempatan untuk
                        meningkatkan penghasilan dan meraih prestasi tertinggi.
                        Bergabunglah sekarang dan jadilah yang terbaik di
                        <b>Agen Affiliate Plus!</b>
                    </p>
                    <p>
                        Jangan lewatkan kesempatan untuk meningkatkan
                        penghasilan dan meraih prestasi tertinggi. Bergabunglah
                        sekarang dan jadilah yang terbaik di Agen Affiliate
                        Plus!
                    </p>
                    <h5>Keuntungan Jadi Agen Affiliate Plus</h5>
                    <ol>
                        <li>
                            <b>Bonus Komisi Bulanan</b><br />
                            Raih komisi tambahan setiap bulan berdasarkan
                            pencapaian tier transaksi downline Anda. Semakin
                            tinggi pencapaian, semakin besar keuntungan yang
                            Anda dapatkan!
                        </li>
                        <li>
                            <b>Bonus Tambahan dari Leader Board</b><br />
                            Berkompetisi dan raih posisi 1, 2, atau 3 di Leader
                            Board Agen Affiliate Plus setiap bulannya! Dapatkan
                            bonus eksklusif berupa points yang bisa ditukarkan
                            dengan hadiah menarik.
                        </li>
                        <li>
                            <b>Dukungan Promosi Lengkap</b><br />
                            Dapatkan akses ke design bahan promosi digital siap
                            pakai untuk Instagram, WhatsApp, TikTok, dan
                            platform lainnya. Lengkap dengan copywriting menarik
                            yang bisa langsung Anda posting! Hemat waktu, tetap
                            profesional, dan maksimalkan penjualan Anda.
                        </li>
                    </ol>
                    <h5>Syarat dan Ketentuan</h5>
                    <ol>
                        <!-- <li>
                            Memiliki minimal 5 Downline Aktif.
                        </li> -->
                        <li>Akun Mitra telah terverifikasi.</li>
                        <li>Akun Mitra Aktif bertransaksi 3 bulan terakhir.</li>
                        <li>Akun memiliki minimal 5 downline aktif.</li>
                        <li>
                            Syarat dan Ketentuan lainnya mengikuti Syarat dan
                            Ketentuan utama {{ VUE_ENV.VUE_APP_NAME }}.
                        </li>
                    </ol>
                </div>
            </div>
            <div
                class="form-button-group shadow-header-footer"
                style="min-height: 66px"
            >
                <button
                    type="button"
                    class="btn btn-warning btn-block"
                    @click="showDialogConfirm('show')"
                    :disabled="customer.affiliate_type == 'PLUS'"
                    v-if="customer.affiliate_type == 'REGULER'"
                >
                    Upgrade Sekarang!
                </button>
                <a
                    href="https://chat.whatsapp.com/F16I40g2xYXJvQ3gW9gwRz"
                    target="_blank"
                    class="btn btn-primary btn-block"
                    v-else
                >
                    Gabung Komunitas Affiliate {{ VUE_ENV.VUE_APP_NAME }}
                </a>
            </div>
        </div>
        <Dialog
            ref="dialog"
            :loading="dialogLoading"
            :title="'Informasi'"
            @confirm="submit()"
        >
            <div style="font-size: 13px; line-height: 18px">
                <p class="text-left">
                    Sudah pastikan kamu memenuhi persyaratan ini :
                </p>
                <ol class="text-left">
                    <li>Akun sudah terverfikasi</li>
                    <li>Akun aktif bertransaksi dalam 3 bulan terakhir</li>
                    <li>Sudah memiliki downline aktif minimal 5 downline</li>
                </ol>
                <p>Anda yakin akan merubah Upgrade ke Agen Affiliate Plus?</p>
            </div>
        </Dialog>
    </div>
</template>
<script>
    import $axios from '../../api.js';
    import { mapActions, mapState } from 'vuex';
    export default {
        data() {
            return {
                loadingApp: false,
                dialogLoading: false,
            };
        },
        computed: {
            ...mapState(['toast', 'VUE_ENV', 'customer', 'setting']),
        },
        methods: {
            ...mapActions(['getCustomer', 'getSetting']),
            showDialogConfirm(value) {
                let element = this.$refs.dialog.$el;
                window.$(element).modal(value);
            },
            submit() {
                this.dialogLoading = true;
                $axios
                    .post('/referral/upgrade-affiliate-plus')
                    .then(response => {
                        this.showDialogConfirm('hide');
                        this.dialogLoading = false;
                        this.getCustomer();
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: response.data.message,
                            tipe: 'default',
                            icon: 'success',
                        });
                    })
                    .catch(error => {
                        this.$store.commit('SET_TOAST', {
                            show: true,
                            message: error.response.data.message,
                            tipe: 'default',
                            icon: 'danger',
                        });
                        this.showDialogConfirm('hide');
                        this.dialogLoading = false;
                    });
            },
        },
        mounted() {},
        destroyed() {
            this.$store.commit('RESET_TOAST');
        },
    };
</script>
